var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.8 3.021c-.272.053-.01-.198-5.225 5.013-4.708 4.706-4.878 4.879-4.95 5.03-.069.148-.073.171-.073.403 0 .23.005.257.07.392.09.19.267.367.456.456.265.125.609.107.871-.045.057-.033.42-.374.814-.766l.711-.705.006 3.76.006 3.762.06.128a.99.99 0 0 0 .677.53c.188.035 13.366.035 13.554 0a.99.99 0 0 0 .677-.53l.06-.128.006-3.761.006-3.761.71.705c.395.392.758.733.815.766.262.152.606.17.871.045.189-.089.366-.266.457-.456.064-.135.07-.162.07-.392 0-.232-.005-.255-.075-.403-.07-.151-.241-.324-4.95-5.03-5.257-5.254-4.95-4.96-5.242-5.015a.9.9 0 0 0-.382.002M9.16 8.109l-2.827 2.827v8.186h11.332v-8.186L14.84 8.11a509 509 0 0 0-2.84-2.828c-.005 0-1.283 1.273-2.838 2.828",
  clipRule: "evenodd"
})));
export default SvgHome2;